import { colors, grayTextBackgrounds, textColors } from './brandStandarts';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import _ from 'lodash';

export const initChartReports = () => {
  Chart.plugins.unregister(ChartDataLabels);
  Chart.defaults.global.defaultFontColor = 'black';
  Chart.defaults.global.defaultFontFamily = 'Arial';
  Chart.defaults.global.defaultFontSize = 16;
};

export const getPercentVal = (value: number) => value + '%';

export const getReportColor = (index: number) =>
  index < colors.length ? colors[index] : 'black'; // return black color when we don`t have enough colors

export const getWrappedHorizontalLabel = (
  label: string,
  sectionsCount: number
) => {
  const totalWidth = 60;
  const maxWidth = 40;
  const minWidth = 5;
  const approxWidth = totalWidth / sectionsCount;
  const width =
    approxWidth > maxWidth
      ? maxWidth
      : approxWidth < minWidth
      ? minWidth
      : approxWidth;
  return getWrappedLabel(label, Math.round(width));
};
export const getWrappedVerticalLabel = (label: string) =>
  getWrappedLabel(label, 25);

export const getWrappedLabel = (label: string, limit: number): string[] => {
  const words = label.split(' ');
  let aux = [];
  let concat = [];

  for (let i = 0; i < words.length; i++) {
    concat.push(words[i]);
    let join = concat.join(' ');
    if (join.length > limit) {
      aux.push(join);
      concat = [];
    }
  }

  if (concat.length) {
    aux.push(concat.join(' ').trim());
  }

  return aux;
};

export const getDataLablesConf = () => ({
  //color: 'white',
  labels: {
    title: {
      font: {
        size: '18',
        weight: 'bold',
      },
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  color: function(context: any) {
    const index = context.dataIndex;
    const bColor = context.dataset.backgroundColor;
    const bColors: string = Array.isArray(bColor) ? bColor[index] : bColor;
    return getTextColor(bColors);
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formatter: function(value: any, _context: any) {
    if (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      value !== 0 &&
      value !== '0'
    ) {
      return value + '%';
    } else {
      return '';
    }
  },
});

const getTextColor = (backgroundColor: string) => {
  return _.findIndex(grayTextBackgrounds, tb => tb === backgroundColor) === -1
    ? textColors[0]
    : textColors[1];
};

export const getTruncatedLabels = (labels: string[]) =>
  _.map(labels, l => _.truncate(l, { length: 100, separator: /,.!? +-_－/ }));
